<!--<div class="order-files-upload-wrapper" fxLayout="column">-->
<!--  <div class="order-files-upload-container" fxFlex="" fxLayout="row wrap" fxLayoutGap="1em" fxLayoutAlign="space-evenly">-->
<!--    <ng-container [ngSwitch]="clearance.value.name">-->
<!--      <mat-card *ngFor="let file of fileTypes" fxFlex="30" style="margin-bottom: 1em">-->
<!--        <mat-card-title>{{file.label}}</mat-card-title>-->
<!--        <mat-card-actions>-->
<!--          <p-fileUpload [url]="'https://devapi.slickchain.com/upload'"></p-fileUpload>-->
<!--        </mat-card-actions>-->
<!--      </mat-card>-->
<!--    </ng-container>-->
<!--  </div>-->
<!--</div>-->
<!--<div class="p-grid order-files-upload-wrapper p-ai-stretch">-->
<!--  <div class="p-col-12 p-md-4 p-sm-6" *ngFor="let file of fileTypes" >-->
<!--          <mat-card>-->
<!--            <mat-card-title>{{file.label}}</mat-card-title>-->
<!--            <mat-card-content>-->
<!--              <p-fileUpload chooseLabel="בחר קובץ" (onUpload)="uploadSuccess($event)" [withCredentials]="true" [name]="file.name" [url]="uploadUrl" (onBeforeUpload)="beforeUpload($event,file.name,file.id)" [cancelLabel]="'בטל העלאה'" [uploadLabel]="'העלה'"></p-fileUpload>-->
<!--            </mat-card-content>-->
<!--          </mat-card>-->
<!--  </div>-->
<!--</div>-->

<mat-accordion fxLayout="row wrap">
  <ng-container *ngIf="orderFiles$|async as DATA">
    <ng-container *ngFor="let file of fileTypes">
      <ng-container *ngIf="file.name==='custom';else regularFile">
        <mat-expansion-panel fxFlex="0 0 100%" fxFlex.lt-md="100%" fxFlexAlign="flex-start">
          <mat-expansion-panel-header>
            <h3>{{ 'DOC_TYPE.ADD_FREE_FILE' | translate }}</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="free-file-container" fxLayout="column" fxLayoutGap="1em">
              <mat-form-field>
                <input type="text" matInput [(ngModel)]="userFile"
                  [placeholder]="'DOCUMENTS.FILE_DESCRIPTION_PLACEHOLDER' | translate">
              </mat-form-field>
              <p-fileUpload [disabled]="!userFile" [chooseLabel]="'DOCUMENTS.CHOOSE_FILE' | translate"
                (onBeforeUpload)="beforeCustomUpload($event,file)" (onUpload)="uploadSuccess($event)"
                [withCredentials]="true" [url]="uploadUrl" [cancelLabel]="'DOCUMENTS.CANCEL_UPLOAD' | translate"
                [uploadLabel]="'DOCUMENTS.UPLOAD' | translate"></p-fileUpload>
            </div>
          </ng-template>
        </mat-expansion-panel>
      </ng-container>
      <ng-template #regularFile>
        <mat-expansion-panel
         #panel="matExpansionPanel"
         [ngClass]="{ 'dragging-category': isDraggingCategory === file.name}"
         fxFlex="0 0 100%" 
          fxFlex.lt-md="100%" 
          fxFlexAlign="flex-start" 
          [disabled]="file.STATUS===1 || file.STATUS===2" 
          (drop)="onDrop($event, $any(panel), file)"
          (dragover)="onDragOver($event,file.name)" 
          (dragleave)="onDragLeave($event,file.name)">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ docTypeLabel(file) }}</mat-panel-title>
            <mat-panel-description *ngIf="file.STATUS===1">{{ 'DOCUMENTS.UPLOADED' | translate }}</mat-panel-description>
            <mat-panel-description *ngIf="file.STATUS===2">{{ 'DOCUMENTS.UPLOADED_APPROVED' | translate }}</mat-panel-description>
            <mat-panel-description *ngIf="file.STATUS===3">{{ 'DOCUMENTS.UPLOADED_REJECTED' | translate }}</mat-panel-description>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="drop-zone" 
              [class.dragging]="isDragging" 
              (dragover)="onDragOver($event,file.name)" 
              (dragleave)="onDragLeave($event,file.name)"
              (drop)="onDrop($event, $any(panel), file)">
              <p>📂 {{ 'DOCUMENTS.DRAG_AND_DROP' | translate }}</p>
            </div>
      
            <p-fileUpload 
              #fileUploader
              [chooseLabel]="'DOCUMENTS.CHOOSE_FILE' | translate"
              [autoUpload]="true"
              (onBeforeUpload)="beforeUpload($event, file.name, file.id)" 
              (onSelect)="onFileSelected($event)"
              (onUpload)="uploadSuccess($event)"
              [withCredentials]="true" 
              [name]="file.name" 
              [url]="uploadUrl"
              [showCancelButton]="false"
              [showUploadButton]="false">
            </p-fileUpload>
          </ng-template>
        </mat-expansion-panel>
      </ng-template>
    </ng-container>
  </ng-container>



</mat-accordion>
<p-toast [position]="'top-left'"></p-toast>